export default {
  company: 'Lighthouse Bay Endoscopy',
  companyShort: 'Lighthouse Bay',
  phone: '(09) 000 1234',
};
